/**
 * Firebase Configuration
 * Staffing Command Center
 * Built and maintained by Angel Carreon (acarreom)
 * Copyright © 2025. All rights reserved.
 */

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAareyG3ZBL_UZO_ot54a40uCd0KnXMloE",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "staffing-board-d5ba5.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "staffing-board-d5ba5",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "staffing-board-d5ba5.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "337392557375",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:337392557375:web:9eba4fdcc8d6efcd05c78a",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-69N4C8CPSR"
};





// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

export default app; 